var _circle, _circle2, _circle3, _circle4, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.25,
    cy: 12.75,
    r: 1.5,
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.25,
    cy: 12.75,
    r: 1.5,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.75,
    cy: 12.75,
    r: 1.5,
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.75,
    cy: 12.75,
    r: 1.5,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 13.5C4.16421 13.5 4.5 13.1642 4.5 12.75C4.5 12.3358 4.16421 12 3.75 12V13.5ZM2.25 12.75H1.5C1.5 13.1642 1.83579 13.5 2.25 13.5V12.75ZM2.25 8.25L1.55364 7.97146C1.51821 8.06005 1.5 8.15459 1.5 8.25H2.25ZM3.75 4.5V3.75C3.44332 3.75 3.16754 3.93671 3.05364 4.22146L3.75 4.5ZM10.5 4.5L11.0857 4.03148C10.9433 3.85357 10.7278 3.75 10.5 3.75V4.5ZM13.5 8.25L12.9143 8.71852C13.0567 8.89643 13.2722 9 13.5 9V8.25ZM15.75 12.75V13.5C16.1642 13.5 16.5 13.1642 16.5 12.75H15.75ZM14.25 12C13.8358 12 13.5 12.3358 13.5 12.75C13.5 13.1642 13.8358 13.5 14.25 13.5V12ZM11.25 13.5C11.6642 13.5 12 13.1642 12 12.75C12 12.3358 11.6642 12 11.25 12V13.5ZM6.75 12C6.33579 12 6 12.3358 6 12.75C6 13.1642 6.33579 13.5 6.75 13.5V12ZM2.25 7.5C1.83579 7.5 1.5 7.83579 1.5 8.25C1.5 8.66421 1.83579 9 2.25 9V7.5ZM13.5 9C13.9142 9 14.25 8.66421 14.25 8.25C14.25 7.83579 13.9142 7.5 13.5 7.5V9ZM8.25 8.25C8.25 8.66421 8.58579 9 9 9C9.41421 9 9.75 8.66421 9.75 8.25H8.25ZM9.75 4.5C9.75 4.08579 9.41421 3.75 9 3.75C8.58579 3.75 8.25 4.08579 8.25 4.5H9.75ZM3.75 12H2.25V13.5H3.75V12ZM3 12.75V8.25H1.5V12.75H3ZM2.94636 8.52854L4.44636 4.77854L3.05364 4.22146L1.55364 7.97146L2.94636 8.52854ZM3.75 5.25H10.5V3.75H3.75V5.25ZM9.91435 4.96852L12.9143 8.71852L14.0857 7.78148L11.0857 4.03148L9.91435 4.96852ZM13.5 9H14.25V7.5H13.5V9ZM14.25 9C14.6642 9 15 9.33579 15 9.75H16.5C16.5 8.50736 15.4926 7.5 14.25 7.5V9ZM15 9.75V12.75H16.5V9.75H15ZM15.75 12H14.25V13.5H15.75V12ZM11.25 12H6.75V13.5H11.25V12ZM2.25 9H13.5V7.5H2.25V9ZM9.75 8.25V4.5H8.25V8.25H9.75Z",
    fill: "#4B465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 13.5C4.16421 13.5 4.5 13.1642 4.5 12.75C4.5 12.3358 4.16421 12 3.75 12V13.5ZM2.25 12.75H1.5C1.5 13.1642 1.83579 13.5 2.25 13.5V12.75ZM2.25 8.25L1.55364 7.97146C1.51821 8.06005 1.5 8.15459 1.5 8.25H2.25ZM3.75 4.5V3.75C3.44332 3.75 3.16754 3.93671 3.05364 4.22146L3.75 4.5ZM10.5 4.5L11.0857 4.03148C10.9433 3.85357 10.7278 3.75 10.5 3.75V4.5ZM13.5 8.25L12.9143 8.71852C13.0567 8.89643 13.2722 9 13.5 9V8.25ZM15.75 12.75V13.5C16.1642 13.5 16.5 13.1642 16.5 12.75H15.75ZM14.25 12C13.8358 12 13.5 12.3358 13.5 12.75C13.5 13.1642 13.8358 13.5 14.25 13.5V12ZM11.25 13.5C11.6642 13.5 12 13.1642 12 12.75C12 12.3358 11.6642 12 11.25 12V13.5ZM6.75 12C6.33579 12 6 12.3358 6 12.75C6 13.1642 6.33579 13.5 6.75 13.5V12ZM2.25 7.5C1.83579 7.5 1.5 7.83579 1.5 8.25C1.5 8.66421 1.83579 9 2.25 9V7.5ZM13.5 9C13.9142 9 14.25 8.66421 14.25 8.25C14.25 7.83579 13.9142 7.5 13.5 7.5V9ZM8.25 8.25C8.25 8.66421 8.58579 9 9 9C9.41421 9 9.75 8.66421 9.75 8.25H8.25ZM9.75 4.5C9.75 4.08579 9.41421 3.75 9 3.75C8.58579 3.75 8.25 4.08579 8.25 4.5H9.75ZM3.75 12H2.25V13.5H3.75V12ZM3 12.75V8.25H1.5V12.75H3ZM2.94636 8.52854L4.44636 4.77854L3.05364 4.22146L1.55364 7.97146L2.94636 8.52854ZM3.75 5.25H10.5V3.75H3.75V5.25ZM9.91435 4.96852L12.9143 8.71852L14.0857 7.78148L11.0857 4.03148L9.91435 4.96852ZM13.5 9H14.25V7.5H13.5V9ZM14.25 9C14.6642 9 15 9.33579 15 9.75H16.5C16.5 8.50736 15.4926 7.5 14.25 7.5V9ZM15 9.75V12.75H16.5V9.75H15ZM15.75 12H14.25V13.5H15.75V12ZM11.25 12H6.75V13.5H11.25V12ZM2.25 9H13.5V7.5H2.25V9ZM9.75 8.25V4.5H8.25V8.25H9.75Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.181171f155f2a6c6be8bf0b82aea882d.svg";
export { ForwardRef as ReactComponent };